import { useSearchParams } from 'react-router';

type UseTab = {
  name: string;
  onTabChange?: (value: string) => void;
};

export const useTab = ({ name, onTabChange }: UseTab) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabValue = searchParams.get(name);

  const updateQueryString = (value: string): void => {
    // replace, not push: breadcrumb Back is navigate(-1) and must leave the page,
    // not walk tabs. Copy: mutating the memoized params breaks blocked navigation.
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set(name, value);
    setSearchParams(nextSearchParams, { replace: true });
  };

  const handleTabChange = (value: string) => {
    if (typeof onTabChange === 'function') {
      onTabChange(value);
    }
    updateQueryString(value);
  };

  return {
    tabValue,
    handleTabChange,
  };
};
